<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <saa-s-child-page-container
    :loading="pageLoading"
    :use-return="true"
    @back="back"
  >
    <template #title>
      <div class="text-h3">
        {{ $t('AadenDoyouServices') }}
      </div>
    </template>
    <div
      class="mt-8"
    >
      <service-card
        v-for="s in productList"
        :key="s.id"
        :checked="selectedProductCode.includes(s.metadata.code)"
        :desc="s.description"
        :name="s.name"
        :one-time="s.realPrice.type"
        :price="s.realPrice.unit_amount/100"
        :recommended="s.recommended"
        @selectServe="toggle(s.metadata.code)"
      />
    </div>
    <template #actions>
      <next-step-button
        :loading="loading"
        class="btnContentSelect"
        @next="next"
      >
        {{ $t('ProceedCheckout') }}
      </next-step-button>
    </template>
  </saa-s-child-page-container>
</template>

<script>

import NextStepButton from '@/views/SaaS/widget/NextStepButton.vue'
import ServiceCard from '@/views/SaaS/widget/ServiceCard.vue'
import { loadProducts, ProductCodes } from '@/model/dataLayer/api/SaaS/product'
import SaaSChildPageContainer from '@/views/SaaS/widget/SaaSChildPageContainer.vue'
import { addProduct, clearProduct, getCurrentSaaSOrderInfo, ProductTypes, readOnlyCode } from '@/views/SaaS/SaaSGuide'
import sortBy from 'lodash-es/sortBy'

export default {
  name: 'SelectService',
  components: {
    SaaSChildPageContainer,
    ServiceCard,
    NextStepButton
  },
  data: function () {
    return {
      pageLoading: true,
      productList: [],
      selectedProductCode: [],
      loading: false
    }
  },
  computed: {
    totalPrice () {
      return (this.realSelectedList.map(it => it.prices.find(x => x.interval === 'month').unit_amount)).reduce(
        (a, b) => {
          return a + b
        }, 0) / 100 ?? 0
    },
    realSelectedList () {
      return this.productList.filter(it => this.selectedProductCode.includes(it.metadata.code))
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    toggle (code) {
      if (readOnlyCode.includes(code)) {
        return
      }
      if (this.selectedProductCode.includes(code)) {
        if (code === 'webService' || code === 'sWebsite') {
          this.selectedProductCode = this.selectedProductCode.filter(it => it !== 'webService' && it !== 'sWebsite')
        } else {
          this.selectedProductCode = this.selectedProductCode.filter(it => it !== code)
        }
      } else {
        if (code === 'webService' || code === 'sWebsite') {
          this.selectedProductCode.push('webService', 'sWebsite')
        } else {
          this.selectedProductCode.push(code)
        }
      }
    },
    async reload () {
      this.pageLoading = true
      const allProducts = await loadProducts()
      const shouldShowCode = [
        ProductCodes.webService, ProductCodes.sWebsite, ProductCodes.sApp, ProductCodes.sPrinterSetting,
        ProductCodes.sProService,
        ProductCodes.sGoodService
      ]
      this.productList = allProducts.filter(it => shouldShowCode.includes(it.metadata.code))
      this.selectedProductCode = [
        ...getCurrentSaaSOrderInfo().selectedProductList.map(it => it.metadata.code)
      ]
      const sort = {
        webService: 1,
        sWebsite: 2,
        sApp: 3,
        sPrinterSetting: 4,
        sProService5: 5,
        sGoodService: 6
      }
      this.productList.map(it => {
        it.sort = sort[it.metadata.code] ?? 99
        return it
      })
      this.productList = sortBy(this.productList, (x) => {
        return x.sort
      })
      this.pageLoading = false
    },
    back () {
      this.$router.push({ name: 'host' })
    },
    async next () {
      this.loading = true
      await this.$router.push({ name: 'order-confirmation' })
      clearProduct(ProductTypes.serve)
      this.realSelectedList.forEach(it => {
        addProduct(it)
      })

      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>
